(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const heroes = [...document.querySelectorAll('.hero')];
    const scrollIndicators = [...document.querySelectorAll('.hero__scroll-indicator')];

    scrollIndicators.forEach((indicator) => {
      indicator.addEventListener('click', (event) => {
        const heroSection = indicator.closest('.shopify-section');
        const nextSection = heroSection?.nextElementSibling;
        const target = nextSection || document.querySelector('#MainContent');

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    if (reduceMotion.matches || heroes.length === 0) return;

    const scrollContainer = document.querySelector('.page-wrapper') || window;
    const benefits = document.querySelector('#shopify-section-template--32000509542730__section_RUYjcU');
    let framePending = false;

    const updateParallax = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const speed = mobile ? 0.14 : 0.38;

      heroes.forEach((hero) => {
        const content = hero.querySelector('.hero__content-wrapper');
        if (!content) return;

        const distance = Math.max(0, -hero.getBoundingClientRect().top);
        const offset = Math.min(180, distance * speed);
        content.style.transform = `translate3d(0, ${offset}px, 0)`;
      });

      if (benefits) {
        const benefitsRect = benefits.getBoundingClientRect();
        const benefitsOffset = Math.max(-48, Math.min(48, -benefitsRect.top * 0.12));
        benefits.style.setProperty('--benefits-scroll-offset', `${benefitsOffset}px`);
      }

      framePending = false;
    };

    const requestParallaxUpdate = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateParallax);
    };

    scrollContainer.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate, { passive: true });
    updateParallax();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["irandre-tryon"]) return;
  try {
    
  class IrandreTryon extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = JSON.parse(this.querySelector('[data-tryon-messages]').textContent);
      const guide = this.querySelector('[data-guide]');
      const help = this.querySelector('[data-open-guide]');
      help.addEventListener('click', () => guide.showModal());
      guide.addEventListener('close', () => { try { localStorage.setItem('irandre-tryon-intro-v1', 'seen'); } catch {} help.focus({preventScroll:true}); });
      let seen = false;
      try { seen = localStorage.getItem('irandre-tryon-intro-v1') === 'seen'; } catch {}
      if (!seen && !window.Shopify?.designMode) guide.showModal();
      this.isGuest = this.dataset.customerAuthenticated !== 'true'; this.guestId = this.getGuestId(); this.guestUpsell = this.querySelector('[data-guest-upsell]');
       this.photoInput = this.querySelector('[data-photo-input]'); this.photoPreview = this.querySelector('[data-photo-preview]'); this.uploadEmpty = this.querySelector('[data-upload-empty]'); this.changeButton = this.querySelector('[data-change-photo]'); this.generateButton = this.querySelector('[data-generate]'); this.result = this.querySelector('[data-result]'); this.resultMedia = this.querySelector('[data-result-media]'); this.resultImage = this.querySelector('[data-result-image]'); this.originalImage = this.querySelector('[data-original-image]'); this.compare = this.querySelector('[data-compare]'); this.compareResult = this.querySelector('[data-compare-result]'); this.compareSlider = this.querySelector('[data-compare-slider]'); this.viewSwitcher = this.querySelector('[data-view-switcher]'); this.viewToggle = this.querySelector('[data-view-toggle]'); this.resultLoading = this.querySelector('[data-result-loading]'); this.resultStatus = this.querySelector('[data-result-status]'); this.shareButton = this.querySelector('[data-share-look]'); this.shareStatus = this.querySelector('[data-share-status]'); this.balanceElement = this.querySelector('[data-credit-balance]'); this.creditPurchase = this.querySelector('[data-credit-purchase]'); this.creditPurchaseToggle = this.querySelector('[data-open-credit-form]'); this.creditPurchaseOpen = false; this.history = this.querySelector('[data-history]'); this.historyGrid = this.querySelector('[data-history-grid]'); this.historyCount = this.querySelector('[data-history-count]'); this.historyEmpty = this.querySelector('[data-history-empty]'); this.photo = null; this.activeGenerationId = ''; this.credits = 0; this.creditsLoaded = !this.balanceElement;
       this.photoInput?.addEventListener('change', () => this.readPhoto(this.photoInput.files[0])); this.changeButton?.addEventListener('click', () => this.photoInput.click()); this.querySelectorAll('[data-cart-item]').forEach((item) => item.addEventListener('change', () => { if (item.checked) this.querySelectorAll('[data-cart-item]').forEach((other) => { if (other !== item && other.dataset.productId === item.dataset.productId) other.checked = false; }); this.updateButton(); })); this.generateButton?.addEventListener('click', () => this.generate()); this.shareButton?.addEventListener('click', () => this.shareLook());
       const incomingVariant = new URLSearchParams(window.location.search).get('tryon_variant');
        if (incomingVariant) {
          const cartItems = [...this.querySelectorAll('[data-cart-item]')];
          const selectedItem = cartItems.find((item) => item.dataset.variantId === incomingVariant);
          if (selectedItem) cartItems.forEach((item) => { item.checked = item === selectedItem; });
        }
        const checkedProducts = new Set();
        const cartItems = [...this.querySelectorAll('[data-cart-item]')];
        cartItems.forEach((item) => { if (!item.checked) return; if (checkedProducts.has(item.dataset.productId)) item.checked = false; else checkedProducts.add(item.dataset.productId); });
        this.querySelector('[data-variant-hint]').hidden = !cartItems.some((item, index) => cartItems.some((other, otherIndex) => otherIndex > index && item.dataset.productId === other.dataset.productId));
       this.updateButton();
      const upload = this.querySelector('[data-upload-area]');
      upload?.addEventListener('dragover', (event) => { event.preventDefault(); upload.classList.add('is-dragging'); });
      upload?.addEventListener('dragleave', () => upload.classList.remove('is-dragging'));
      upload?.addEventListener('drop', (event) => { event.preventDefault(); upload.classList.remove('is-dragging'); if (!this.busy) this.readPhoto(event.dataTransfer.files[0]); });
       if (this.balanceElement) { this.loadCredits(); this.loadHistory(); }
       this.historyGrid?.addEventListener('click', (event) => { if (event.target.closest('a')) return; const card = event.target.closest('[data-history-look]'); if (card) this.openHistoryLook(card.dataset.historyImage, card.dataset.historyId); }); this.historyGrid?.addEventListener('keydown', (event) => { if (event.key !== 'Enter' && event.key !== ' ') return; if (event.target.closest('a')) return; const card = event.target.closest('[data-history-look]'); if (card) { event.preventDefault(); this.openHistoryLook(card.dataset.historyImage, card.dataset.historyId); } });
       this.compareDivider = this.querySelector('[data-compare-divider]'); const setComparePosition = (value) => { const position = Math.max(0, Math.min(100, Number(value) || 0)); this.compareSlider.value = position; this.compareResult.style.clipPath = `inset(0 ${100 - position}% 0 0)`; this.compareDivider.style.left = `${position}%`; }; this.compareSlider?.addEventListener('input', () => setComparePosition(this.compareSlider.value)); this.compareResult.style.clipPath = 'inset(0 50% 0 0)'; this.compareDivider.style.left = '50%'; this.compareDragging = false; this.compare?.addEventListener('pointerdown', (event) => { if (this.resultMedia.classList.contains('is-single')) return; event.preventDefault(); this.compareDragging = true; this.compare.setPointerCapture?.(event.pointerId); setComparePosition((event.clientX - this.compare.getBoundingClientRect().left) / this.compare.getBoundingClientRect().width * 100); }); this.compare?.addEventListener('pointermove', (event) => { if (this.compareDragging) { event.preventDefault(); setComparePosition((event.clientX - this.compare.getBoundingClientRect().left) / this.compare.getBoundingClientRect().width * 100); } }); this.compare?.addEventListener('pointerup', () => { this.compareDragging = false; }); this.compare?.addEventListener('pointercancel', () => { this.compareDragging = false; }); this.viewToggle?.addEventListener('click', () => { const single = !this.resultMedia.classList.contains('is-single'); this.resultMedia.classList.toggle('is-single', single); this.viewToggle.textContent = single ? 'Compare' : 'Result only'; this.viewToggle.setAttribute('aria-pressed', String(!single)); if (single) { this.compareResult.style.width = '100%'; this.compareResult.style.clipPath = 'none'; this.compareDivider.hidden = true; this.compareSlider.disabled = true; } else { this.compareSlider.disabled = false; this.compareDivider.hidden = false; setComparePosition(this.compareSlider.value || 50); } });
       this.creditSlider = this.querySelector('[data-credit-slider]'); this.creditQuantity = this.querySelector('[data-credit-quantity]'); if (this.creditSlider && this.creditQuantity) { const syncCreditQuantity = (event) => { const slider = event.target.closest?.('[data-credit-slider]'); if (slider && this.contains(slider)) this.creditQuantity.textContent = slider.value; }; this.creditQuantity.textContent = this.creditSlider.value; this.addEventListener('input', syncCreditQuantity); this.addEventListener('change', syncCreditQuantity); } this.creditPurchaseToggle?.addEventListener('click', () => { this.creditPurchaseOpen = true; this.updateCreditPurchase(); });
    }
    readPhoto(file) {
      if (!file || this.busy) return;
      const notice = this.querySelector('[data-photo-error]');
      const fail = (message) => { notice.textContent = message; notice.hidden = false; this.photoInput.value = ''; };
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > Number(this.dataset.maxFileSize)) return fail(this.messages.file);
      const token = this.photoToken = (this.photoToken || 0) + 1;
      const reader = new FileReader();
      reader.onerror = () => { if (token === this.photoToken) fail(this.messages.read); };
      reader.onload = async () => {
        const image = new Image(); image.src = reader.result;
        try { await image.decode(); } catch { if (token === this.photoToken) fail(this.messages.read); return; }
        if (token !== this.photoToken || !this.isConnected) return;
        const canvas = document.createElement('canvas');
        const maxDimension = 1600;
        const scale = Math.min(1, maxDimension / Math.max(image.naturalWidth, image.naturalHeight));
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
        const compressed = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.82));
        if (!compressed) { if (token === this.photoToken) fail(this.messages.read); return; }
        const compressedReader = new FileReader();
        compressedReader.onload = () => { if (token !== this.photoToken || !this.isConnected) return; this.photo = compressedReader.result; this.photoPreview.src = this.photo; this.photoPreview.hidden = false; this.uploadEmpty.hidden = true; this.changeButton.hidden = false; notice.hidden = true; this.updateButton(); };
        compressedReader.onerror = () => { if (token === this.photoToken) fail(this.messages.read); };
        compressedReader.readAsDataURL(compressed);
      };
      reader.readAsDataURL(file);
    }
     selectedItems() { return [...this.querySelectorAll('[data-cart-item]:checked')].map((item) => ({ product_id:item.dataset.productId, title:item.dataset.title, variant:item.dataset.variant, price:item.dataset.price, image:new URL(item.dataset.image, window.location.origin).href, url:item.dataset.url ? new URL(item.dataset.url, window.location.origin).href : '' })); }
    getGuestId() { const key = 'irandre-tryon-guest-id-v1'; try { const stored = localStorage.getItem(key); if (/^[a-f0-9-]{36}$/i.test(stored || '')) return stored; const id = crypto.randomUUID(); localStorage.setItem(key, id); return id; } catch { try { const stored = sessionStorage.getItem(key); if (/^[a-f0-9-]{36}$/i.test(stored || '')) return stored; const id = crypto.randomUUID(); sessionStorage.setItem(key, id); return id; } catch { return crypto.randomUUID(); } } }
    apiUrl(path = '') { const localPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname); const endpoint = localPreview ? 'https://irandre.com/apps/irandre-tryon' : this.dataset.apiEndpoint; const url = new URL(endpoint, window.location.origin); url.pathname = `${url.pathname.replace(/\/$/, '')}${path}`; if (this.guestId) url.searchParams.set('guest_id', this.guestId); return url.href; }
    async loadHistory() { try { const response = await fetch(this.apiUrl('/history'), { credentials:'same-origin' }); const data = await response.json(); if (!response.ok || !Array.isArray(data.generations)) throw new Error(); this.renderHistoryCompact(data.generations); } catch { if (this.history) this.history.hidden = false; if (this.historyEmpty) { this.historyEmpty.hidden = false; this.historyEmpty.textContent = 'History is temporarily unavailable.'; } } }
     renderHistoryCompact(generations) { if (!this.history) return; this.history.hidden = false; this.historyCount.textContent = `${generations.length} look${generations.length === 1 ? '' : 's'}`; this.historyEmpty.hidden = generations.length > 0; this.historyGrid.innerHTML = generations.map((generation) => { const products = (generation.garments || []).map((item) => item.url ? `<a class="irandre-tryon__history-product" href="${this.escape(item.url)}" data-product-link data-product-url="${this.escape(item.url)}"><img src="${this.escape(item.image || '')}" alt="" loading="lazy"><span><b title="${this.escape(item.title)}">${this.escape(item.title)}</b><small title="${this.escape(item.variant || '')}">${this.escape(item.variant || '')}</small></span></a>` : `<span class="irandre-tryon__history-product" data-history-product-fallback data-product-title="${this.escape(item.title)}"><img src="${this.escape(item.image || '')}" alt="" loading="lazy"><span><b title="${this.escape(item.title)}">${this.escape(item.title)}</b><small>Checking availability…</small></span></span>`).join(''); return `<article class="irandre-tryon__history-card" data-history-look data-history-id="${this.escape(generation.id)}" data-history-image="${this.escape(generation.output_url)}" tabindex="0" role="button" aria-label="View past look" onclick="if (!event.target.closest('a')) this.closest('irandre-tryon').openHistoryLook(this.dataset.historyImage,this.dataset.historyId)" onkeydown="if ((event.key === 'Enter' || event.key === ' ') && !event.target.closest('a')) { event.preventDefault(); this.closest('irandre-tryon').openHistoryLook(this.dataset.historyImage,this.dataset.historyId) }"><img src="${this.escape(generation.output_url)}" alt="Virtual try-on result" loading="lazy"><div class="irandre-tryon__history-copy"><time datetime="${this.escape(generation.created_at)}">${new Date(generation.created_at.replace(' ','T') + 'Z').toLocaleDateString()}</time><div class="irandre-tryon__history-products">${products || '<span class="is-unavailable">Products unavailable</span>'}</div></div></article>`; }).join(''); this.historyGrid.querySelectorAll('[data-product-link]').forEach(async (link) => { try { const productUrl = new URL(link.dataset.productUrl, window.location.origin); productUrl.search = ''; productUrl.hash = ''; const response = await fetch(`${productUrl.href.replace(/\/$/, '')}.js`, { credentials:'same-origin' }); if (response.status === 404) { link.classList.add('is-unavailable'); link.removeAttribute('href'); link.querySelector('small').textContent = 'Unavailable'; } } catch {} }); this.historyGrid.querySelectorAll('[data-history-product-fallback]').forEach(async (item) => { try { const query = encodeURIComponent(item.dataset.productTitle || ''); const response = await fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=1`, { credentials:'same-origin' }); const data = await response.json(); const product = data.resources?.results?.products?.[0]; if (product?.url) { item.outerHTML = `<a class="irandre-tryon__history-product" href="${this.escape(product.url)}"><img src="${this.escape(item.querySelector('img')?.src || '')}" alt="" loading="lazy"><span><b title="${this.escape(item.dataset.productTitle)}">${this.escape(item.dataset.productTitle)}</b><small>View product</small></span></a>`; } else { item.classList.add('is-unavailable'); item.querySelector('small').textContent = 'Unavailable'; } } catch { item.classList.add('is-unavailable'); item.querySelector('small').textContent = 'Unavailable'; } }); }
     async openHistoryLook(imageUrl, generationId) { if (!imageUrl || !this.result) return; this.activeGenerationId = generationId || ''; this.shareButton.hidden = !this.activeGenerationId; if (this.shareStatus) this.shareStatus.hidden = true; this.result.hidden = false; this.result.setAttribute('aria-busy','false'); this.resultMedia.classList.add('is-single'); this.viewSwitcher.hidden = true; this.resultLoading.hidden = true; this.originalImage.hidden = true; this.compareSlider.disabled = true; this.compareDivider.hidden = true; this.compareResult.style.width = '100%'; this.compareResult.style.clipPath = 'none'; this.resultImage.src = imageUrl; this.resultImage.hidden = false; const heading = this.result.querySelector('h2'); const eyebrow = this.result.querySelector('.irandre-tryon__eyebrow'); if (eyebrow) eyebrow.hidden = false; if (eyebrow) eyebrow.textContent = 'FROM YOUR ARCHIVE'; if (heading) heading.textContent = 'Past look'; this.resultStatus.textContent = 'A saved result from your Try-On archive.'; try { await this.resultImage.decode(); } catch {} this.result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'}); }
     renderHistory(generations) { if (!this.history) return; this.history.hidden = false; this.historyCount.textContent = `${generations.length} look${generations.length === 1 ? '' : 's'}`; this.historyEmpty.hidden = generations.length > 0; this.historyGrid.innerHTML = generations.map((generation) => { const products = (generation.garments || []).map((item) => item.url ? `<a href="${this.escape(item.url)}" data-product-link>${this.escape(item.title)}${item.variant ? ` · ${this.escape(item.variant)}` : ''}</a>` : `<span class="is-unavailable">${this.escape(item.title)} · unavailable</span>`).join('<br>'); return `<article class="irandre-tryon__history-card"><img src="${this.escape(generation.output_url)}" alt="Virtual try-on result" loading="lazy"><div class="irandre-tryon__history-copy"><time datetime="${this.escape(generation.created_at)}">${new Date(generation.created_at.replace(' ','T') + 'Z').toLocaleDateString()}</time><strong>${products || 'Products unavailable'}</strong></div></article>`; }).join(''); this.historyGrid.querySelectorAll('[data-product-link]').forEach(async (link) => { try { const response = await fetch(link.href, { method:'HEAD', credentials:'same-origin' }); if (!response.ok) { link.classList.add('is-unavailable'); link.textContent += ' · unavailable'; link.removeAttribute('href'); } } catch { link.classList.add('is-unavailable'); link.textContent += ' · unavailable'; link.removeAttribute('href'); } }); }
     escape(value) { return String(value || '').replace(/[&<>"']/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character])); }
    async shareLook() {
      if (!this.activeGenerationId || !this.shareButton) return;
      this.shareButton.disabled = true;
      this.shareStatus.hidden = true;
      try {
        const response = await fetch(this.apiUrl('/share'), { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ generation_id:this.activeGenerationId }) });
        const data = await response.json();
        if (!response.ok || !data.share_path) throw new Error(data.error || 'We could not publish this look. Please try again.');
        const shareUrl = new URL(data.share_path, window.location.origin).href;
        const shareData = { title:'My Irandré look', text:'I created this look with Irandré. What do you think?', url:shareUrl };
        if (navigator.share) {
          try { await navigator.share(shareData); this.shareStatus.textContent = 'Your look is ready to travel.'; }
          catch (error) { if (error?.name !== 'AbortError') throw error; return; }
        } else {
          await navigator.clipboard.writeText(shareUrl);
          this.shareStatus.textContent = 'Share link copied — send it anywhere.';
        }
      } catch (error) {
        this.shareStatus.textContent = error?.message || 'We could not publish this look. Please try again.';
      } finally {
        this.shareStatus.hidden = false;
        this.shareButton.disabled = false;
      }
    }
    async loadCredits() {
      try {
        const response = await fetch(this.apiUrl('/credits'), { credentials:'same-origin' });
        const data = await response.json();
        if (!response.ok || !Number.isFinite(data.balance)) throw new Error();
        this.credits = data.balance; this.creditsLoaded = true; this.balanceElement.textContent = String(data.balance); this.updateCreditPurchase(); this.updateButton();
      } catch {
        this.creditsLoaded = false; this.balanceElement.textContent = '—'; this.updateCreditPurchase(); this.updateButton();
      }
    }
    updateCreditPurchase() {
      if (this.isGuest) { if (this.guestUpsell) this.guestUpsell.hidden = !this.creditsLoaded || this.credits > 0; return; }
      if (!this.creditPurchase || !this.creditPurchaseToggle) return;
      const showPurchase = this.creditPurchaseOpen || (this.creditsLoaded && this.credits <= 0);
      this.creditPurchase.hidden = !showPurchase;
      this.creditPurchaseToggle.hidden = showPurchase || !this.creditsLoaded;
    }
    updateButton() {
      if (!this.generateButton) return;
      const count = this.selectedItems().length;
      this.generateButton.disabled = this.busy || !this.creditsLoaded || this.credits < 1 || !this.photo || count < 1 || count > 15;
      this.querySelector('[data-count]').textContent = `${this.messages.count}: ${count}`;
      this.querySelector('[data-selection-hint]').textContent = !this.creditsLoaded ? this.messages.missing : this.credits < 1 ? (this.isGuest ? 'Sign in with email to keep creating looks.' : 'Buy a Try-On credit to create another look.') : !count || count > 15 ? this.messages.select : !this.photo ? this.messages.photo : this.messages.ready;
    }
    async generate() {
      const garments = this.selectedItems();
      if (this.busy || !this.photo || garments.length < 1 || garments.length > 15) return;
      this.busy = true; this.updateButton();
       this.activeGenerationId = ''; this.shareButton.hidden = true; this.shareStatus.hidden = true; this.result.hidden = false; this.result.setAttribute('aria-busy','true'); this.resultImage.hidden = true; this.originalImage.hidden = false; this.originalImage.src = this.photo; this.compareResult.style.width = '100%'; this.compareResult.style.clipPath = 'inset(0 50% 0 0)'; this.compareSlider.disabled = false; this.compareDivider.hidden = false; this.compareSlider.value = 50; this.resultMedia.classList.remove('is-single'); this.viewSwitcher.hidden = true;
       const label = this.resultLoading; label.hidden = false; label.textContent = this.messages.loading;
      const heading = this.result.querySelector('h2'); const eyebrow = this.result.querySelector('.irandre-tryon__eyebrow');
      eyebrow.hidden = true; heading.textContent = this.messages.loading; this.resultStatus.textContent = this.messages.loading;
      this.result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      this.querySelectorAll('[data-cart-item], [data-photo-input], [data-change-photo]').forEach((input) => input.disabled = true);
      try {
        if (!this.dataset.apiEndpoint) throw new Error(this.messages.missing);
        const idempotencyKey = crypto.randomUUID().replaceAll('-', '');
         const response = await fetch(this.apiUrl('/generate'), {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({person_image:this.photo,garment_images:garments.map((item) => item.image),garments,idempotency_key:idempotencyKey}),signal:AbortSignal.timeout(60000)});
         const responseText = await response.text();
         let data;
         try { data = JSON.parse(responseText); } catch { throw new Error(response.ok ? this.messages.error : `Try-On service error (${response.status}). Please try again.`); }
        if (data.status === 'failed') throw new Error(data.error || this.messages.error);
        if (!response.ok) throw new Error(data.error || this.messages.error);
        if (data.status === 'pending' && data.generation_id) {
          const generationId = String(data.generation_id);
          const startedAt = Date.now();
          while (Date.now() - startedAt < 600000) {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            const statusResponse = await fetch(this.apiUrl(`/generation/${encodeURIComponent(generationId)}`), {credentials:'same-origin',signal:AbortSignal.timeout(30000)});
            const statusText = await statusResponse.text();
            let statusData;
            try { statusData = JSON.parse(statusText); } catch { throw new Error(this.messages.error); }
            if (statusData.status === 'completed') { data = statusData; break; }
            if (statusData.status === 'failed' || !statusResponse.ok) throw new Error(statusData.error || this.messages.error);
          }
        }
        if (!data.image) throw new Error(this.messages.error);
        const url = new URL(data.image); if (url.protocol !== 'https:') throw new Error(this.messages.error);
        this.resultImage.src = url.href; await this.resultImage.decode();
         this.activeGenerationId = String(data.generation_id || ''); this.shareButton.hidden = !this.activeGenerationId; this.resultImage.hidden = false; label.hidden = true; this.viewSwitcher.hidden = false; heading.textContent = this.messages.done; this.resultStatus.textContent = this.messages.done; this.credits = Number(data.balance); if (this.balanceElement && Number.isFinite(this.credits)) this.balanceElement.textContent = String(this.credits); this.loadHistory();
      } catch (error) { label.textContent = '↻'; heading.textContent = this.messages.error; this.resultStatus.textContent = error?.message || (this.dataset.apiEndpoint ? this.messages.error : this.messages.missing); }
      finally { this.busy = false; this.result.setAttribute('aria-busy','false'); this.querySelectorAll('[data-cart-item], [data-photo-input], [data-change-photo]').forEach((input) => input.disabled = false); this.updateButton(); }
    }
  }
  if (!customElements.get('irandre-tryon')) customElements.define('irandre-tryon', IrandreTryon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hotspots"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    const sections = [...document.querySelectorAll('.section-product-hotspots')];
    if (sections.length === 0) return;

    const scrollTargets = [window, document.querySelector('.page-wrapper')].filter(Boolean);
    let framePending = false;

    const updateLookReveal = () => {
      const viewportHeight = window.innerHeight;

      sections.forEach((section) => {
        const content = section.querySelector('.section-product-hotspots__content');
        if (!content) return;

        const { top } = section.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (viewportHeight * 0.86 - top) / (viewportHeight * 0.62)));
        const inset = (1 - progress) * 28;
        const scale = 0.72 + progress * 0.28;
        const radius = 18 + (1 - progress) * 10;

        content.style.setProperty('--look-progress', progress.toFixed(3));
        content.style.setProperty('--look-inset-x', `${inset.toFixed(2)}%`);
        content.style.setProperty('--look-scale', scale.toFixed(3));
        content.style.setProperty('--look-radius', `${radius.toFixed(1)}px`);
      });

      framePending = false;
    };

    const requestLookRevealUpdate = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateLookReveal);
    };

    scrollTargets.forEach((target) => {
      target.addEventListener('scroll', requestLookRevealUpdate, { passive: true });
    });
    window.addEventListener('resize', requestLookRevealUpdate, { passive: true });
    updateLookReveal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__irandreHeroParallaxInitialized) return;
    window.__irandreHeroParallaxInitialized = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const heroSections = [...document.querySelectorAll('[id$="__section_Fh7TFQ"]')];
    const hero = heroSections[0];
    const scrollIndicators = [...document.querySelectorAll('.homepage-hero-scroll-indicator')];

    if (hero) {
      const cta = hero.querySelector('.button-custom');

      const prefetchCtaDestination = () => {
        if (!(cta instanceof HTMLAnchorElement) || !cta.href) return;

        const destination = new URL(cta.href, window.location.href);
        if (destination.origin !== window.location.origin) return;
        if (document.querySelector('link[data-hero-cta-prefetch]')) return;

        const prefetchLink = document.createElement('link');
        prefetchLink.rel = 'prefetch';
        prefetchLink.as = 'document';
        prefetchLink.href = destination.href;
        prefetchLink.dataset.heroCtaPrefetch = 'true';
        document.head.appendChild(prefetchLink);
      };

      prefetchCtaDestination();
      cta?.addEventListener('pointerenter', prefetchCtaDestination, { once: true, passive: true });
      cta?.addEventListener('focus', prefetchCtaDestination, { once: true });

      if (cta && !reduceMotion.matches) {
        const ripple = document.createElement('span');
      ripple.className = 'homepage-hero-ripple';
      ripple.setAttribute('aria-hidden', 'true');
      hero.appendChild(ripple);
      let navigationPending = false;

      const triggerWaterRipple = () => {

        const heroRect = hero.getBoundingClientRect();
        const ctaRect = cta.getBoundingClientRect();
        const rippleX = ctaRect.left - heroRect.left + ctaRect.width / 2;
        const rippleY = ctaRect.top - heroRect.top + ctaRect.height / 2;
        const rippleRadius = Math.max(
          Math.hypot(rippleX, rippleY),
          Math.hypot(heroRect.width - rippleX, rippleY),
          Math.hypot(rippleX, heroRect.height - rippleY),
          Math.hypot(heroRect.width - rippleX, heroRect.height - rippleY)
        );
        const rippleDiameter = rippleRadius * 2;

        ripple.style.setProperty('--ripple-x', `${rippleX}px`);
        ripple.style.setProperty('--ripple-y', `${rippleY}px`);
        ripple.getAnimations().forEach((animation) => animation.cancel());
        ripple.animate(
          [
            { width: '36px', height: '36px', opacity: 0, offset: 0 },
            { opacity: 0.82, offset: 0.1 },
            { opacity: 0.45, offset: 0.7 },
            { width: `${rippleDiameter}px`, height: `${rippleDiameter}px`, opacity: 0, offset: 1 },
          ],
          {
            duration: 2200,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
            fill: 'forwards',
          }
        );
      };

      cta.addEventListener('pointerenter', triggerWaterRipple);
      cta.addEventListener('focus', () => {
        if (cta.matches(':focus-visible')) triggerWaterRipple();
      });
      cta.addEventListener('click', (event) => {
        if (
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          cta.target === '_blank'
        ) {
          return;
        }

        event.preventDefault();
        if (navigationPending) return;

        navigationPending = true;
        prefetchCtaDestination();
        window.location.assign(cta.href);
      });
      }
    }

    scrollIndicators.forEach((indicator) => {
      indicator.addEventListener('click', (event) => {
        const heroSection = indicator.closest('.shopify-section');
        const nextSection = heroSection?.nextElementSibling;
        const target = nextSection || document.querySelector('#MainContent');

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    if (reduceMotion.matches || heroSections.length === 0) return;

    const desktopScrollContainer = window.matchMedia('(min-width: 990px)').matches;
    const scrollContainer = desktopScrollContainer ? document.querySelector('.page-wrapper') || window : window;
    const benefits = document.querySelector('[id$="__section_RUYjcU"]');
    let framePending = false;

    const updateParallax = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const speed = mobile ? 0.15 : 0.3;

      const heroDistance = Math.max(0, -(heroSections[0]?.getBoundingClientRect().top || 0));
      const indicatorProgress = Math.min(1, heroDistance / (mobile ? 180 : 240));

      scrollIndicators.forEach((indicator) => {
        indicator.style.opacity = `${1 - indicatorProgress}`;
        indicator.style.clipPath = `inset(0 0 ${indicatorProgress * 100}% 0)`;
        indicator.style.pointerEvents = indicatorProgress >= 0.98 ? 'none' : 'auto';
      });

      heroSections.forEach((heroSection) => {
        const content = heroSection.querySelector('.section-content-wrapper');
        if (!content) return;

        const distance = Math.max(0, -heroSection.getBoundingClientRect().top);
        const offset = Math.min(mobile ? 120 : 140, distance * speed);
        content.style.transform = `translate3d(0, ${offset}px, 0)`;
      });

      if (benefits) {
        const benefitsRect = benefits.getBoundingClientRect();
        const benefitsOffset = Math.max(-40, Math.min(40, -benefitsRect.top * 0.1));
        benefits.style.setProperty('--benefits-scroll-offset', `${benefitsOffset}px`);
      }

      framePending = false;
    };

    const requestParallaxUpdate = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateParallax);
    };

    scrollContainer.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate, { passive: true });
    updateParallax();
  })();

  } catch(e) { console.error(e); }
})();
})();
